import { all, takeEvery, put, call } from 'redux-saga/effects';
import Api from 'src/helpers/api';
import { sendRequest } from 'src/helpers/saga';
import { logger } from 'src/helpers/logger';
import actions from './actions';
import actionTypes from './actionTypes';

const api = new Api('pricing/engine_versions');

export function* fetchFormData(): Generator<any, void, any> {
  try {
    // No failure action is handed to `sendRequest`: it would dispatch FETCH_ERROR itself on a no-response
    // failure, on top of the one this saga already dispatches. `errorType` only adds that second dispatch.
    const result = yield call(sendRequest, api.loadFormData, {});

    if (result?.status === 200 && result.data?.success?.data) {
      yield put(actions.fetchSuccess(result.data.success.data));

      return;
    }

    yield put(actions.fetchError());
  } catch (error) {
    logger.error(error);
    yield put(actions.fetchError());
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.FETCH_REQUEST, fetchFormData)]);
}
